import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import { motion } from "framer-motion";
import HeaderTypography from "../../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../../components/v2/Typography/ParagraphTypography";

const useStyles = makeStyles(() => ({
	JoinUsRoot: {
		background: "radial-gradient(circle at 100% 0%, rgba(32, 142, 236, 0.3) 0%, transparent 35%), radial-gradient(circle at 0% 0%, rgba(32, 142, 236, 0.3) 0%, transparent 35%), radial-gradient(circle at 90% 130%, rgba(32, 142, 236, 0.3) 0%, transparent 35%), #011C33",
		backgroundSize: "cover",
		paddingTop: "65px",
		paddingBottom: "65px",
		"@media(max-width: 1024px)": {
			padding: "65px 15px",
		},
		"@media(max-width: 600px)": {
			padding: "40px 15px",
		},
	},
	joinHeading: {
		fontSize: "56px",
		fontWeight: 600,
		marginBottom: "48px !important",
		"@media(max-width:1200px)": {
			fontSize: "48px",
		},
		"@media(max-width:992px)": {
			fontSize: "40px",
		},
		"@media(max-width:600px)": {
			fontSize: "32px",
			marginBottom: "32px !important",
		},
	},
	joinPara: {
		marginBottom: "40px",
		fontSize: "18px",
		"@media(max-width:600px)": {
			fontSize: "16px",
			marginBottom: "28px",
		},
	},
}));

function JoinUs() {
	const classes = useStyles();

	return (
		<Box className={classes.JoinUsRoot}>
			<Container>
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5 }}
					viewport={{ once: false }}
				>
					<HeaderTypography
						className={classes.joinHeading}
						color="common.white"
						component="h2"
						lineHeight={1.2}
						mt={0}
						textAlign="center"
					>
						Ready to make an impact?
					</HeaderTypography>
				</motion.div>
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5, delay: 0.15 }}
					viewport={{ once: false }}
				>
					<ParagraphTypography
						className={classes.joinPara}
						color="common.white"
						maxWidth={900}
						mt={0}
						mx="auto"
						textAlign="center"
					>
						Join our team of talented individuals building the future of customer relationships. Your next career move starts here.
					</ParagraphTypography>
				</motion.div>
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.5, delay: 0.25 }}
					viewport={{ once: false }}
					style={{ display: "flex", justifyContent: "center" }}
				>
					<Box display="flex" justifyContent="center">
						<a
							className="primaryButton font-20 colorWhite"
							href="https://angel.co/company/pepper-cloud-pte-1/jobs"
							rel="nofollow noreferrer"
							target="_blank"
						>
							Join us now
						</a>
					</Box>
				</motion.div>
			</Container>
		</Box>
	);
}

export default JoinUs;
